export default __webpack_public_path__ + "static/media/2471.fc396fd1.png";